<template>
  <div>
    <div class="search">
      <div class="search-wrapper">
        <input
          class="input"
          type="text"
          @input="search"
          ref="searchbox"
          :placeholder="$t('dictionary.search.placeholder')"
        />
        <inline-svg
          class="search-icon"
          :class="ltr ? 'dir-right' : 'dir-left'"
          width="40px"
          :src="require('../../assets/svg/searchbaricon.svg').default"
        >
        </inline-svg>
      </div>
      <div class="options" v-if="matchWords.length">
        <div
          class="opt flex"
          v-for="word of matchWords"
          :key="word.idd"
          @click="selectWord(word)"
        >
          <div class="heb hebFlex" v-if="word.heb">
            <div class="translated-word">
              <span>{{ word.Eng }}</span>
            </div>
            <div class="original-word">
              <span>{{ word.heb }}</span>
            </div>
          </div>
        </div>
        <div class="opt flex addWordCls" @click="addWord">
          {{ $t("dictionary.search.title") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { utilService } from '../../services/util.service';
import AudioBtn from "../Shared/audioBtn.vue";
import { wordService } from '../../services/wordService';

const opensearchEndpoint = process.env.VUE_APP_OPENSEARCH_URL;
const wordsIndexName = localStorage.getItem('wordsIndex');

export default {
  props: [],
  data() {
    return {
      matchWords: [],
      value: "",
      isLoading: false,
      ltr: localStorage.getItem("srcDirection") == "ltr",
    };
  },
  created() {},
  mounted() {
    this.focusSearch();
  },
  methods: {
    focusSearch() {
      this.$refs.searchbox.focus();
    },
    addWord() {
      this.matchWords = [];
      this.$emit("addWord");
    },
    getSplitWord(word, value, beforeOrAfter) {
      const idx = word.indexOf(value);
      if (!idx) {
        if (!beforeOrAfter) {
          return word.slice(idx, this.value.length);
        } else if (beforeOrAfter === "after") {
          return word.slice(this.value.length - idx, word.length);
        } else {
          return "";
        }
      } else if (idx > 0) {
        if (beforeOrAfter === "before") {
          return word.slice(0, idx);
        } else if (beforeOrAfter === "after") {
          return word.slice(idx + this.value.length, word.length);
        } else {
          return word.slice(idx, idx + this.value.length);
        }
      }
    },
    async selectWord(word) {
      this.$emit("selectedWord", word);
      this.$store.commit({ type: "setFamily", family: await wordService.getSentences(word.Eng)});
      this.matchWords = [];
    },
    search(e) {
      const { value } = e.target;
      this.value = value;
      this.isLoading = true;
      const debounced = utilService.debounce(this.getMatchWords, 750);
      debounced();
    },
    async getMatchWords() {
      this.$emit('selectedWord', null);
      const query = {
        query: {
          multi_match: {
            fields: ["Eng", "heb"],
            query: this.value,
            fuzziness: "AUTO",
            operator:  "and"
          }
        },
        size: 40000,
      };
  
      const apiUrl = `${opensearchEndpoint}/${wordsIndexName}/_search`;
  
      try {
        const credentials = Buffer.from(`admin:${process.env.VUE_APP_OPENSEARCH_PASSWORD}`).toString('base64');
        const authHeader = `Basic ${credentials}`;
  
        const response = await axios.post(apiUrl, query, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': authHeader,
          },
          withCredentials: false,
        });
  
        const results = response.data.hits.hits.map(hit => Object.assign({}, hit._source, { objectID: hit._id }));;
  
        const matchWords = results.map(word => {
          const before = this.getSplitWord(word.heb, this.value, 'before');
          const mark = this.getSplitWord(word.heb, this.value);
          const after = this.getSplitWord(word.heb, this.value, 'after');
  
          return {
            ...word,
            before,
            mark,
            after,
          };
        });
  
        this.matchWords = matchWords;
        this.isLoading = false;
  
      } catch (error) {
        console.error('Error retrieving data from OpenSearch:', error.response ? error.response.data : error.message);
        this.isLoading = false;
      }
    },
  },
  components: { AudioBtn }
};
</script>
<style scoped>
span {
  /* white-space: pre; */
  font-size: 18px;
}

.search-wrapper {
  position: relative;
  .dir-left {
    left: 4px;
  }
  .dir-right {
    right: 4px;
  }
}

.search-wrapper:has(+ .options) input {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.search-wrapper:has(input:focus) + .options {
  border-top-color: #555fff;
}

.search-icon {
  position: absolute;
  top: 16px;
  z-index: 100;
}

.search {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.input {
  margin: 0 auto;
  width: 100%;
  font-size: 20px;
  position: relative;
  border: 2px solid #bbbbc7;
  border-radius: 8px;
  padding: 10px 20px;
  /* -webkit-box-shadow: 2px 2px 7px rgb(60 101 188 / 50%), -2px -2px 3px #fff;
  box-shadow: 2px 2px 7px rgb(60 101 188 / 50%), -2px -2px 3px #fff; */
  z-index: 1;
  background: white;

  &:focus {
    border: 2px solid #555fff;
  }
}

.options {
  width: 100%;
  list-style: none;
  overflow-y: auto;
  position: absolute;
  top: calc(100% - 2px);
  border: 2px solid #bbbbc7;
  border-radius: 0 0 4px 4px;
  box-sizing: border-box;
  background: #fff;
  font-size: 1.5rem;
  z-index: 99;
  height: auto;
  max-height: min(520px, calc(100vh - 280px));
}

.opt {
  padding: 12px 0;
  cursor: pointer;
  line-height: 1;
  text-align: center;
  justify-content: center;

  &:not(:last-child) {
    border-bottom: 1px solid #d5d5de;
  }
}

.opt:hover {
  background: #d4e1f8;
}

.mark {
  background-color: yellow;
}

.addWordCls {
  font-size: 16px;
  font-weight: 500;
  border-top: 1px solid #bbbbc7;
  padding: 20px 0;
}

.hebFlex {
  display: flex;
  width: 100%;
  flex-direction: column;
  white-space: break-spaces;
}

.original-word {
  color: #555fff;
}
</style>


// WEBPACK FOOTER //
// search.vue?6893824b